import { apiHelper, sessionHelper } from '@/utils'
import { API } from '@/constants'
import moment from 'moment';

export const closePeriodServices = {
  getAllClosePeriods,
  getClosePeriod,
  updateClosePeriod,
  createClosePeriod,
  updateClosePeriodStatus
};

const MODULE = {
  PERIOD: 'company-location-closed-periods',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllClosePeriods(filter) {
  const requestOptions = {
    params: {
      page: filter.pageNumber,
      size: filter.pageSize,
      is_locked: filter.isLocked,
      is_active: filter.isActive,
    }
  }

  let array = filter.searchArray
  array.forEach((word, index) => {
    if (word != null || word != '') {
      var searchParam = `search_words[${index}]`
      requestOptions.params[searchParam] = word
    }
  })

  if (sessionHelper.getUserType == "STAFF") {
    requestOptions.params['company_location_uuid'] = sessionHelper.getStaffLocationUUID()
  }

  return apiHelper(API_URL).get(`/${MODULE.PERIOD}`, requestOptions)
}

export function getClosePeriod(id) {
  return apiHelper(API_URL).get(`/${MODULE.PERIOD}/${id}`)
}

export function updateClosePeriod(data) {
  const requestOptions = {
    name: data.name,
    start_operate_time: moment(data.startTime, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm"),
    close_operate_time: moment(data.closeTime, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm"),
    is_whole_day: data.isWholeDay,
  }

  return apiHelper(API_URL).put(`/${MODULE.PERIOD}/${data.id}`, requestOptions)
}

export function createClosePeriod(data) {
  const requestOptions = {
    company_uuid: data.companyID,
    company_location_uuid: data.companyLocationID,
    name: data.name,
    start_operate_time: moment(data.startTime, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm"),
    close_operate_time: moment(data.closeTime, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm"),
    is_whole_day: data.isWholeDay,
    is_company: data.isCompany,
  }


  return apiHelper(API_URL).post(`/${MODULE.PERIOD}`, requestOptions)
}

export function updateClosePeriodStatus(data) {
  const requestOptions = {
    is_active: data.isActive
  }

  return apiHelper(API_URL).patch(`/${MODULE.PERIOD}/${data.id}`, requestOptions)

}